import React from 'react'
import type { HTMLAttributes } from 'react'
import { isClientAnonymous } from '@/checkout-instore-legacy/customer/utils'

import { InsightsNotificationBar } from '../InsightsNotificationBar'
import { CartMessage } from '../CartMessage'
import { useCustomer } from '../../../../../../core/globalState/customer'
import { useCheckout } from '../../../../state'

export type CartAlertsProps = HTMLAttributes<HTMLDivElement>

export const CartAlerts = ({ css, ...props }: CartAlertsProps) => {
  const { customer } = useCustomer()
  const { checkout } = useCheckout()
  const { profile, openCart } = customer
  const showProfile = !isClientAnonymous(profile)
  const showInsights =
    showProfile ||
    checkout?.clientData?.email === openCart?.customerIdentification

  return (
    <div {...props}>
      {showInsights && <InsightsNotificationBar customer={customer} />}
      <CartMessage />
    </div>
  )
}
